export default __webpack_public_path__ + "static/media/main-logo@2x.2f9e5f65.png";